var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create"},[_c('PageBanner',[_vm._v("Create Event")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }